import { useQuery } from '@tanstack/react-query';
import { ManifestApiResponse } from '@manifest-cyber/types/interface/apiResponse';
import { AxiosProxy } from '../../../../api/axiosProxy/axiosProxy';

export interface PolicyFormData {
  outdatedModel: {
    threshold: {
      duration: number;
      unit: string;
    };
    severity: string;
  };
  recentlyCreated: {
    threshold: {
      duration: number;
      unit: string;
    };
    severity: string;
  };
  flaggedCountries: {
    countries: string[];
    severity: string;
  };
  trustedOrganizations: {
    suppliers: string[];
    severity: string;
  };
  missingDatasetSeverity: string;
  approvedLicenseSeverity: string;
  reviewLicenseSeverity: string;
  forbiddenLicenseSeverity: string;
}

type AiPoliciesResponse = ManifestApiResponse<PolicyFormData>;

export const useAiPolicies = () => {
  return useQuery<AiPoliciesResponse>({
    queryKey: ['ai-policies'],
    queryFn: async (): Promise<AiPoliciesResponse> => {
      // Commented out API call - replace with mock for testing
      const response = await AxiosProxy.get({
        url: 'policies/ai',
      });
      return response;

      // return new Promise((resolve) => {
      //   setTimeout(() => {
      //     resolve(mockAiPoliciesData);
      //   }, 500);
      // });
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
};
